import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box, Text, Row, Col, Icon } from '@cubeyou-team/hx-react-components';
import { useSelector } from 'react-redux';

import { getItemIcon } from 'src/utils';
import { getCurrentProductDataSources } from 'src/selectors/myCompany';

const ItemsRecapList = ({ title, text, items }) => {
  const productDataSources = useSelector(state =>
    getCurrentProductDataSources(state)
  );
  const recapText = useMemo(() => {
    if (text) {
      return (
        <Box mB="medium">
          <Text
            size="small"
            title={text}
            style={{
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}
          >
            {text}
          </Text>
        </Box>
      );
    }

    return (
      <React.Fragment>
        {items.map(item => (
          <Box mB="medium" key={item.id}>
            <Row>
              <Col span="auto">
                <Icon
                  size="small"
                  icon={getItemIcon(item, productDataSources)}
                  variant={'dark'}
                />
              </Col>
              <Col span={10}>
                <Text
                  size="small"
                  title={item.label}
                  style={{
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                  }}
                >
                  {item.label}
                </Text>
              </Col>
            </Row>
          </Box>
        ))}
      </React.Fragment>
    );
  }, [text, items, productDataSources]);

  return (
    <React.Fragment>
      {title && (
        <Box mB="medium">
          <Text style={{ whiteSpace: 'pre-line' }}>{title}</Text>
        </Box>
      )}
      {recapText}
    </React.Fragment>
  );
};

ItemsRecapList.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
};

export default ItemsRecapList;
